import type React from "react";
import { useTheme, type Theme } from "./useTheme";

// Compact 3-segment switch for the app header. Uses simple inline
// SVGs so we don't pull a dependency just for three icons.
const SunIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth={2}
    strokeLinecap="round"
    strokeLinejoin="round"
    className="w-3.5 h-3.5"
  >
    <circle cx={12} cy={12} r={4} />
    <path d="M12 2v2M12 20v2M4 12H2M22 12h-2M19.07 4.93l-1.41 1.41M6.34 17.66l-1.41 1.41M19.07 19.07l-1.41-1.41M6.34 6.34L4.93 4.93" />
  </svg>
);

const MoonIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth={2}
    strokeLinecap="round"
    strokeLinejoin="round"
    className="w-3.5 h-3.5"
  >
    <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z" />
  </svg>
);

const SystemIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth={2}
    strokeLinecap="round"
    strokeLinejoin="round"
    className="w-3.5 h-3.5"
  >
    <rect x={2} y={3} width={20} height={14} rx={2} />
    <path d="M8 21h8M12 17v4" />
  </svg>
);

export function ThemeToggle() {
  const { theme, setTheme } = useTheme();
  const items: Array<{ id: Theme; label: string; icon: React.ReactElement }> = [
    { id: "light", label: "Light", icon: SunIcon },
    { id: "system", label: "Auto", icon: SystemIcon },
    { id: "dark", label: "Dark", icon: MoonIcon },
  ];
  return (
    <div
      role="radiogroup"
      aria-label="Theme"
      className="inline-flex rounded-md border border-zinc-200 dark:border-slate-700 bg-zinc-50 dark:bg-slate-900 p-0.5"
    >
      {items.map((it) => (
        <button
          key={it.id}
          role="radio"
          aria-checked={theme === it.id}
          onClick={() => setTheme(it.id)}
          title={it.label}
          className={`flex items-center gap-1 rounded px-1.5 py-1 text-xs ${
            theme === it.id
              ? "bg-white dark:bg-slate-700 text-zinc-900 dark:text-slate-100 shadow-sm"
              : "text-zinc-500 dark:text-slate-400 hover:text-zinc-700 dark:hover:text-slate-200"
          }`}
        >
          {it.icon}
        </button>
      ))}
    </div>
  );
}
